import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useInvalidateResearchedAdsQuery } from './get-researched-ads-query'
import type {
    AddAdToPoolRequestBody,
    AddAdToPoolRequestParams,
    AddAdToPoolResponseData,
    RemoveAdFromPoolRequestParams,
    RemoveAdFromPoolResponseData,
} from 'api/dist/routes/organization/[organization_id]/brands/[brand_slug]/research/ads/[ad_uuid]/pools/[pool_key]'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'

export type IAddAdToPoolMutationParams = AddAdToPoolRequestParams & AddAdToPoolRequestBody
export type IRemoveAdFromPoolMutationParams = RemoveAdFromPoolRequestParams

export class AddAdToPoolMutation {
    static async call(api: IApi, params: IAddAdToPoolMutationParams) {
        const { category, description, ...pathParams } = params
        return api
            .post<
                AddAdToPoolResponseData,
                AddAdToPoolRequestBody
            >(`/organization/${pathParams.organization_id}/brands/${pathParams.brand_slug}/research/ads/${pathParams.ad_uuid}/pools/${pathParams.pool_key}`, { category, description })
            .then((res) => res.data)
    }
}

export class RemoveAdFromPoolMutation {
    static async call(api: IApi, params: IRemoveAdFromPoolMutationParams) {
        return api
            .delete<RemoveAdFromPoolResponseData>(
                `/organization/${params.organization_id}/brands/${params.brand_slug}/research/ads/${params.ad_uuid}/pools/${params.pool_key}`
            )
            .then((res) => res.data)
    }
}

export function useAddAdToPoolMutation() {
    const { api, apiParams } = useApiToolbox()
    const invalidateAds = useInvalidateResearchedAdsQuery()

    return useApiMutation({
        mutationFn: (params: Omit<IAddAdToPoolMutationParams, 'organization_id' | 'brand_slug'>) =>
            AddAdToPoolMutation.call(api, {
                ...params,
                organization_id: apiParams.organizationId,
                brand_slug: apiParams.brandSlug,
            }),
        onSuccess: () => {
            invalidateAds()
        },
    })
}

export function useRemoveAdFromPoolMutation() {
    const { api, apiParams } = useApiToolbox()
    const invalidateAds = useInvalidateResearchedAdsQuery()

    return useApiMutation({
        mutationFn: (params: Omit<IRemoveAdFromPoolMutationParams, 'organization_id' | 'brand_slug'>) =>
            RemoveAdFromPoolMutation.call(api, {
                ...params,
                organization_id: apiParams.organizationId,
                brand_slug: apiParams.brandSlug,
            }),
        onSuccess: () => {
            invalidateAds()
        },
    })
}
